import { createSlice } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

import SharesRepository from "repositories/SharesRepository";

const initialState = {
  errors: null,
};

const sharesSlice = createSlice({
  name: "shares",
  initialState,
  reducers: {
    createSharesFail(state, { payload }) {
      state.errors = payload;
    },
  },
});

export const { actions } = sharesSlice;
export default sharesSlice.reducer;

export const useSharesActions = () => {
  const dispatch = useDispatch();

  const createShare = (params) => {
    return SharesRepository.create(params).catch((error) => {
      dispatch(sharesSlice.actions.createShareFail(error));
      throw new Error(error);
    });
  };

  return {
    createShare,
  };
};
